import React, { useEffect, useState, lazy } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { addToCart } from "../../../_actions/cart.actions";
import axios from "../../../axios";
import CustomBreadCrumb from "../../Other/CustomBreadCrumb";
import { Loading } from "../../Other/Loading";
import OverlayContainer from "../../Overlay/OverlayContainer";
// import CoursePreview from "./CoursePreview/CoursePreview";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import RenderRating from "../../Other/StarRating/RenderRating";
import RateCourse from "../../Other/StarRating/RateCourse";
import "../../Courses/CourseDetails/courseDetails.css";
import { courseActions } from "../../../_actions";
import ChapterOverView from "./chapterOverView";
import { getS3URL, handleViewsFormat } from "../../../_helpers";
import CartButton from "../../Courses/CourseTile/CartButton/CartButton";
// // import Share from "../CourseShare/courseShare";
import { deleteWishlist, addWishlist } from "../../../_actions/cart.actions";
import moment from "moment";
import Footer from "../../Other/Footer";
import TopBar from "../../Other/TopBar";
import CoursePreview from "../../CoursePreview/CoursePreview";

function CourseDetail({ match }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { loggedIn } = useSelector((state) => state.authentication);
  const param = match.params.courseId.match(/\w[^-]*$/g);
  const [course, setCourse] = useState(null);
  const [showCoursePreview, setShowCoursePreview] = useState(false);
  const [showRateCourseModal, setShowRateCourseModal] = useState(false);
  const [shareShow, setShareShow] = useState(false);
  const [rating, setRating] = useState(0);
  const [rateLogin, setRateLogin] = useState(true);
  const [favourite, setFavourite] = useState(false);

  // Define the function that fetches the data from API
  const fetchData = (courseId) => {
    // 3139
    setCourse(null);
    axios
      .get(`course/${courseId}`)
      .then((response) => {
        setCourse(response.data.data.recordset[0]);
        setRating(response.data.data.recordset[0].Rating);
        setFavourite(Boolean(response.data.data.recordset[0].isWishlisted));
      })
      .catch((error) => console.log(error));
  };
  console.log(course);
  useEffect(() => {
    fetchData();
  }, []);
  const handleCourseViews = (courseId) => {
    axios.post(`course/${courseId}/views`);
  };

  const handleCoursePreview = (event) => {
    event.preventDefault();
    setShowCoursePreview(true);
  };

  const firstName = course?.instructorInfo?.firstName;
  const lastName = course?.instructorInfo?.lastName;

  const handleCloseModal = () => {
    setShowRateCourseModal(false);
  };

  const handleShowModal = () => {
    setShowRateCourseModal(true);
  };

  const handleAddCourseToCart = (event, course) => {
    event.preventDefault();
    dispatch(addToCart(course.ID));
  };

  useEffect(() => {
    if (param != null) {
      fetchData(param[0]);
      if (loggedIn) {
        handleCourseViews(param[0]);
      }
    }
  }, [param[0]]);

  const handleClose = () => {
    setShareShow(!shareShow);
  };
  const likeHandler = (courseId, isWishlisted) => {
    if (loggedIn && favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(deleteWishlist(courseId));
      setFavourite(false);
    } else if (loggedIn && !favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(addWishlist(courseId));
    } else {
      history.push("/login");
    }
  };

  const handleRate = () => {
    if (!loggedIn) {
      history.push("/login");
    }
  };
  const handleRateCourse = (courseId) => {
    const Courserating = {
      courseId: courseId,
      rating: rating,
    };

    setShowRateCourseModal(false);
  };

  return (
    <>
      <TopBar />
      {course === null ? (
        <div className="loading-div">
          <Loading />
        </div>
      ) : (
        <div>
          <div className="min-div">
            <div className="inner-div">
              <div className="flex-wrap">
                <CustomBreadCrumb />
                <div className="int-flex-wrapper">
                  <div
                    className="wishlist-wrapper"
                    onClick={() => likeHandler(param[0], 0)}
                  >
                    <span className="icon icon-like"></span>
                  </div>

                  <div className="share-course-wrapper" onClick={handleClose}>
                    <i className="topic-share-icon"></i>
                  </div>
                </div>
              </div>

              <div className="course-banner-main">
                <div className="banner-course-left">
                  <div className="course-header">{course.CourseName}</div>
                  <div className="banner-sub">{course.courseOneLiner}</div>
                  <div className="EnrollmentFee">
                    <div className="course-price-wrapper">
                      {course.isPurchased ? (
                        <div className="purchase-wrapper">
                          {t("Purchased Course")}
                        </div>
                      ) : (
                        <>
                          <div className="course-price">
                            <span>{course && course.EnrollmentFee}</span>
                          </div>
                          <div className="coupon-code">
                            <ul>
                              <li>Got a Discount code?</li>
                              <li></li>
                            </ul>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="star-rateingmenu">
                      <div className="rating-title">
                        <div className="sub-title">{t("Reviews")}</div>
                        <div className="ratings-wrapper">
                          <RenderRating
                            loggedIn={loggedIn}
                            rateLogin={rateLogin}
                            ratings={
                              rating === 0 ? Number(course.Rating) : rating
                            }
                            handleRate={handleRate}
                            handleShowModal={handleShowModal}
                          />
                          {loggedIn && (
                            <div
                              className="rate-course-title"
                              onClick={handleShowModal}
                            >
                              {t("Rate this Course?")}
                            </div>
                          )}
                          {/* {showRateCourseModal && (
                            <RateCourse onClose={handleCloseModal} />
                          )} */}
                          {showRateCourseModal &&
                            loggedIn &&
                            (course.isPurchased ? (
                              <RateCourse
                                onClose={handleCloseModal}
                                rating={rating}
                                setRating={setRating}
                                handleRateCourse={handleRateCourse}
                                course={course}
                                showRateCourseModal={showRateCourseModal}
                                setShowRateCourseModal={setShowRateCourseModal}
                              />
                            ) : (
                              <div className="rate-course rate-course-login">
                                <div className="arrow-up"></div>
                                <div
                                  className="close-button-login"
                                  onClick={() => setShowRateCourseModal(false)}
                                >
                                  <i className="icon check"></i>
                                </div>
                                <div className="star-text">
                                  Please buy this course first !
                                </div>

                                <div className="button-wrapper">
                                  <div
                                    className="btn btn-back"
                                    onClick={() =>
                                      setShowRateCourseModal(false)
                                    }
                                  >
                                    <a>Later</a>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div>
                        <p className="sub-title">
                          {t("Course views")} &nbsp;
                          {handleViewsFormat(
                            course?.courseViews === null
                              ? 0
                              : course.courseViews
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="banner-profile-div">
                    <div className="banner-profile-left">
                      <img
                        src={`${
                          course?.instructorInfo?.profileImage !== null
                            ? course?.instructorInfo?.profileImage
                            : "https://cdn-icons-png.flaticon.com/512/147/147144.png"
                        }`}
                        alt=""
                      />
                    </div>

                    <div className="banner-profile-right">
                      <div className="banner-header">
                        {`${firstName} ${lastName}`}
                      </div>
                      <div className="banner-sub-text">
                        {t("Instructor Profile")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-course-right">
                  <div className="flex-right">
                    <ul>
                      {/* {course?.courseType !== "liveCourse" && (
                        <li className="pre-btn">
                          {" "}
                          <a
                            href="/#"
                            role="button"
                            onClick={handleCoursePreview}
                          >
                            <span>{t("Preview Course")}</span>
                          </a>{" "}
                        </li>
                      )} */}
                      {!course.isPurchased && course?.Status !== 2 && (
                        <AuthorizedWrapper authorizedRoles={["Student"]}>
                          <li className="Basket">
                            <CartButton post={course} />
                          </li>
                        </AuthorizedWrapper>
                      )}
                    </ul>

                    <div className="course-info-wrapper">
                      <div className="banner-sub2">
                        <ul>
                          <li>{t("Languages")}:</li>
                          <li>{t(course.Language)}</li>
                        </ul>
                      </div>

                      <div className="banner-sub2">
                        <ul>
                          <li>
                            {t("Created on")}:{" "}
                            {moment(course?.CreatedOn).format("MMM DD, YYYY")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showCoursePreview && (
            <OverlayContainer>
              <CoursePreview
                courseName={course.CourseName}
                courseImg={getS3URL(course.imageFiles[0].fileName)}
                courseVid={getS3URL(course.videoFiles[0].fileName)}
                toogle={setShowCoursePreview}
              />
            </OverlayContainer>
          )}

          {course && <ChapterOverView course={course} />}

          {/* {shareShow && <Share handleClose={handleClose} />} */}
        </div>
      )}
      <Footer />
    </>
  );
}
export default CourseDetail;
